module.exports = __webpack_public_path__ + "media/V80.ff2df80d.mp4";